import React from 'react'
import * as S from './styles'

export default function Loader({ color = 'green', size = 'sm' }) {
  return <S.Loader size={size} color={color} />
}
